import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { actions as userActions } from "../../../../../redux/modules/user";
import SchoolBadge from "../../../../../components/School/SchoolBadge";
import "./style.css";
import "../../../../../index.css";
/**
 * 专业查询院校列表使用的列表项
 */
class SchoolItem extends Component {
  render() {
    const { item, url, from } = this.props;
    return (
      <NavLink
        onClick={(event) => this.handleJump(event)}
        to={url + item.hashId + "?from=" + from}
        className="majorquery_school_item_box"
      >
        <div className="majorquery_school_item_box_badge fl">
          <SchoolBadge
            src={item.schoolBadge}
            name={item.schoolName}
            placeholderFontSize={20}
          ></SchoolBadge>
        </div>
        <div className="majorquery_school_item_box_major fl">
          <div className="majorquery_school_item_box_major_embed_school">
            {item.schoolName}
          </div>
          {item.cuSchoolMajorVOS.map((majorvo, index) => {
            return (
              <div
                style={{
                  paddingBottom:
                    index === item.cuSchoolMajorVOS.length - 1 ? "0px" : "15px",
                  borderBottom:
                    index === item.cuSchoolMajorVOS.length - 1
                      ? "0px"
                      : " 1px solid #ededed",
                }}
                key={index}
                className="majorquery_school_item_box_major_div"
              >
                <div className="majorquery_school_item_box_major_embed">
                  <div className="majorquery_school_item_box_major_embed_majortype">
                    <div className="major_circle fl"></div>
                    <div style={{ width: "93%" }} className="fl">
                      专业（类）名称：
                      <span
                        dangerouslySetInnerHTML={{ __html: majorvo.majorType }}
                      ></span>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <div className="majorquery_school_item_box_major_embed_majors">
                    <div className="major_circle fl"></div>
                    <div style={{ width: "93%" }} className="fl">
                      专业名称：
                      <span
                        dangerouslySetInnerHTML={{ __html: majorvo.majors }}
                      ></span>
                    </div>
                    <div className="clear"></div>
                  </div>
                  <div className="majorquery_school_item_box_major_embed_subject">
                    <div
                      style={{
                        backgroundColor:
                          majorvo.level === "专科" ? "#8bbded" : "#ff9b00",
                      }}
                      className="fl school_level"
                    >
                      {majorvo.level}
                    </div>
                    <div
                      style={{
                        borderColor: majorvo.subjectColor,
                        color: majorvo.subjectColor,
                      }}
                      className="fl school_subject"
                    >
                      {majorvo.requireSubject}
                    </div>
                    <div className="clear"></div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="clear"></div>
      </NavLink>
    );
  }
  handleJump = (event) => {
    let userInfo = this.props.userInfo;
    const { dispatch } = this.props;
    //如果没有登录 ，阻止它跳转，并且弹出登录框
    if (userInfo.isLogin === false) {
      event.preventDefault(); //阻止默认事件
      dispatch(userActions.setShowLogin(true));
    }
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};
export default connect(mapStateToProps)(SchoolItem);



// WEBPACK FOOTER //
// ./src/containers/MajorQuerySchool/SchoolList/components/SchoolItem/index.js